<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Toggle } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
		import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { real_id } from 'src/helpers/interface_helpers';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let loading = false;

	let checked = $settingsStore?.[`em1:${device.channel}`]?.reverse;

	const setMeasurement = async () => {
		loading = true;
		const res = await gen2Request(device, 'EM1.SetConfig', {
			id: device.channel,
			config: {
				reverse: checked,
			},
		});
		await onSettingsResponse(res, device);
		loading = false;
	};

	const toggleMeasurement = async () => {
		if (loading) return;
		checked = !checked;
		if ($showNewLayout) {
			await setMeasurement();
		}
	};
</script>

<Toggle
	class="mb-s"
	size="m"
	{checked}
	on:click={toggleMeasurement}
	disabled={loading}
	id="toggle-lb0hfte"
	>{$format('emeter_invert_measurement_description', {
		default: 'Invert measurement direction in software per current transformer.',
	})}
</Toggle>
{#if !$showNewLayout}
	<Button {loading} width="full" size="m" on:click={setMeasurement}>{$format('button_save')}</Button>
{/if}
